<template>
  <div id="SchoolContactManage">
    <div v-if="SchoolContactManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <button
          href="#"
          @click="AddSchoolContact()"
          class="btn btn-outline-success"
          type="button"
          style="font-size: 14px; text-align: right"
        >
          新增高中職窗口
        </button>
        <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSchoolContactXLSX/'

            "
            v-show="total > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>
      </div>

      <div>
        <span class="red_star">＊</span>學校名稱:
        <input
          type="text"
          class="form-control"
          v-model="inputData2.schoolName"
          ref="inputData2.schoolName"
          placeholder="請輸入學校名稱"
        />

      </div>
      <div style="text-align: center">
      <button
        href="#"
        @click.prevent="getSchoolContact()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          目前高中職窗口共 {{ total }}筆
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"

            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 1em">序號</b-th>
                <b-th style="min-width: 5em">學校名稱</b-th>
                <b-th style="min-width: 3em">單位</b-th>
                <b-th style="min-width: 2em">姓名</b-th>
                <b-th style="min-width: 2em">職稱</b-th>
                <b-th style="min-width: 5em">電話/手機電話</b-th>
                <b-th style="min-width: 10em">EMail</b-th>
                <b-th style="min-width: 8em">負責業務</b-th>
                <b-th style="min-width: 8em">管理</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="item in filteredDocs"
                :key="item.sid"
                :index="item.sid"
                v-bind:style="{
                  background: selectedRowIndex == item.sid ? headerColor : '',
                }"
                @click="selectedRowIndex = item.sid"
              >
                <b-td style="text-align: left">
                  {{ item.sid }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.schoolName }}
                </b-td>
                <b-td style="text-align: right">
                  {{ item.unitName }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.contactName }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.jobTitle }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.cellPhone }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.eMail }}
                </b-td>
                <b-td style="text-align:left">
                  {{ item.business }}
                </b-td>
                <b-td v-if="item.isDelete == false">
                  <button
                    href="#"
                    @click.prevent="EditSchoolContact(item.sid)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>
                  <button
                    href="#"
                    @click.prevent="Delete(item.sid)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    刪除
                  </button>
                  <button
                    href="#"
                    @click.prevent="remove(item.sid)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    隱藏
                  </button>
                </b-td>
                <b-td v-else>
                  <button
                    href="#"
                    @click.prevent="EditSchoolContact(item.sid)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>
                  <button
                    href="#"
                    @click.prevent="Delete(item.sid)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    刪除
                  </button>
                  <button
                    href="#"
                    @click.prevent="DisplaySchoolContact(item.sid)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    顯示
                  </button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            :limit="21"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>

      <b-modal size="xl" ref="AddSchoolContact" hide-footer>
        <template #modal-title> 新增高中職窗口 </template>
        <AddSchoolContact
          @hideModal="hideModal('AddSchoolContact')"
        ></AddSchoolContact>
      </b-modal>
      <b-modal size="xl" ref="EditSchoolContact" hide-footer>
        <template #modal-title> 修改高中職窗口 </template>
        <EditSchoolContact
          :sn="sn"
          @hideModal="hideModal('EditSchoolContact')"
        ></EditSchoolContact>
      </b-modal>
      <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認隱藏此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
          >取消隱藏</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
          >隱藏確認</b-button
        >
      </b-modal>
      <b-modal ref="d-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認刪除此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM2"
          >取消刪除</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM2"
          >刪除確認</b-button
        >
      </b-modal>
    </div>
  </div>
</template>


<script>
import AddSchoolContact from "@/components/AddSchoolContact.vue";
import EditSchoolContact from "@/components/EditSchoolContact.vue";
import * as tools from "../tool";
export default {
  name: "SchoolContactManage",

  data() {
    return {
      originalSchoolData: null,
      courseName: null,
      SchoolContactManageShow: false,
      sn: 0,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: [],
      inputData2: {
      sid: null,
      schoolName: null,
      unitName: null,
      contactName: null,
      jobTitle: null,
      cellPhone: null,
      eMail: null,
      business: null,
    },
      localInputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,

      pageSize: 10,
    };
  },
  components: {
    AddSchoolContact,
    EditSchoolContact,
  },
  methods: {

    checkInput() {
      this.inputFlag = false;

      if (tools.empty(this.inputData2.schoolName)) {
        alert("請輸入學校名稱");
        this.inputFlag = true;
        return;
      }



    },
    getSchoolContact(){
      this.checkInput();
      let vm = this;

      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetSchoolContact/", this.inputData2)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
        });

    },

    getAllSchoolContact() {
      let vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetAllSchoolContact/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
        });
    },
    AddSchoolContact() {
      var vm = this;
      vm.$refs["AddSchoolContact"].show();
    },
    EditSchoolContact(sn) {
      var vm = this;
      vm.sn = sn;
      vm.$refs["EditSchoolContact"].show();
    },
    remove(sn) {
      this.sn = sn;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },
    Delete(sn) {
      this.sn = sn;
      this.$refs["d-modal"].show();
    },
    cancalRM2() {
      this.$refs["d-modal"].hide();
    },
    hideModal(name) {
      this.$refs[name].hide();
      this.getAllSchoolContact();
    },
    confirmRM() {
      //隱藏資料
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/RemoveSchoolContact/".concat(this.sn)
        )
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,隱藏成功");
            vm.getAllSchoolContact();
          } else {
            tools.showAlert(vm, "danger", "對不起,隱藏失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    confirmRM2() {
      //Delete資料
      this.$refs["d-modal"].hide();
      var vm = this;
      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/DeleteSchoolContact/".concat(this.sn)
        )
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
            vm.getAllSchoolContact();
          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    DisplaySchoolContact(sn) {
      //display資料
      this.sn = sn;
      var vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/DisplaySchoolContact/".concat(vm.sn))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,顯示成功");
            vm.getAllSchoolContact();
          } else {
            tools.showAlert(vm, "danger", "對不起,顯示失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
  },
  computed: {
    filteredDocs: function () {
      let data = [];

      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },

    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created SchoolContactManageView =====");
    let vm = this;
    vm.getAllSchoolContact();

  },
  mounted() {
    console.log("======mounted SchoolContactManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.SchoolContactManageShow = true;


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
